import React from 'react';
import PropTypes from 'prop-types';

import { Box, Grid, Paper } from '@mui/material';

import MHxSoap from './components/MHx_Soap/MHxSoap';
import SoapLeft from './components/SoapLeft/SoapLeft';

import {
  soapDetailColumnSx,
  soapDetailGridItemSx,
  soapDetailGridSx,
  soapDetailPaperSx,
  soapDetailRootSx,
  soapMetaWrapperSx
} from './SoapDetailStyles';
import Meta from './components/Meta/Meta';

const SoapDetail = ({ className, ...rest }) => {
  return (
    <Box className={className} {...rest} sx={soapDetailRootSx}>
      <Paper elevation={0} sx={soapDetailPaperSx}>
        <Box sx={soapMetaWrapperSx}>
          <Meta />
        </Box>

        <Grid
          container
          columnSpacing={1}
          alignItems="stretch"
          sx={soapDetailGridSx}>
          <Grid size={{ xs: 12, md: 8 }} sx={soapDetailGridItemSx}>
            <Box sx={soapDetailColumnSx}>
              <SoapLeft />
            </Box>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }} sx={soapDetailGridItemSx}>
            <Box sx={soapDetailColumnSx}>
              <MHxSoap />
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

SoapDetail.propTypes = {
  className: PropTypes.string
};

export default SoapDetail;
